export const columnData = {
  sources: {
    expand: {
      label: '',
      classMod: 'expand',
    },
    collection: {
      label: 'Collection',
      classMod: 'collection',
    },
    sourceNumber: {
      label: 'Source Number',
      classMod: 'source-number',
    },
    callNumber: {
      label: 'Call Number',
      classMod: 'call-number',
    },
    author: {
      label: 'Author',
      classMod: 'author',
    },
    title: {
      label: 'Title',
      classMod: 'title',
    },
    description: {
      label: 'Description',
      classMod: 'description',
    },
    inscription: {
      label: 'Inscriptions',
      classMod: 'inscription',
    },
    msEntries: {
      label: 'MS. Music',
      classMod: 'ms-entries',
    },
  },
  entries: {
    expand: {
      label: '',
      classMod: 'expand',
    },
    collection: {
      label: 'Collection',
      classMod: 'collection',
    },
    sourceNumber: {
      label: 'Source Number',
      classMod: 'source-number',
    },
    location: {
      label: 'Location',
      classMod: 'location',
    },
    title: {
      label: 'Title',
      classMod: 'title',
    },
    composer: {
      label: 'Composer',
      classMod: 'composer',
    },
    vocalPart: {
      label: 'Vocal Part/s',
      classMod: 'vocal-part',
    },
    key: {
      label: 'Key/s',
      classMod: 'key',
    },
    melodicIncipit: {
      label: 'Melodic Incipit',
      classMod: 'melodic-incipit',
    },
    textIncipit: {
      label: 'Text Incipit',
      classMod: 'text-incipit',
    },
    isSecular: {
      label: 'Secular',
      classMod: 'is-secular',
    },
    notes: {
      label: 'Notes',
      classMod: 'notes',
    },
  },
  collections: {
    expand: {
      label: '',
      classMod: 'expand',
    },
    collection: {
      label: 'Collection',
      classMod: 'collection',
    },
    description: {
      label: 'Description',
      classMod: 'description',
    },
  },
};
